import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import RepairForm from "./RepairForm";

function RepairFormSave() {
  const { id } = useParams();
  return <RepairForm id={id} id2={0} FromCome={"SAVE"} />;
}

export default RepairFormSave;
